export default __webpack_public_path__ + "static/71-e3bcbc01c66ff6a197bad2763c7261b4.png";